module.exports = __webpack_public_path__ + "static/media/italic.27c0cde9.svg";